import React from "react";
import { css, cx } from "@emotion/css";

import EditorMenu from "./EditorMenu";

const EditorToolbar = React.forwardRef(({ className, ...props }, ref) => (
  <EditorMenu
    {...props}
    ref={ref}
    className={cx(
      className,
      css`
        position: relative;
        padding: 1px 18px 17px;
        margin: 0 -20px;
        border-bottom: 2px solid #eee;
        margin-bottom: 20px;
      `
    )}
  />
));

export default EditorToolbar;
